import { hideSnackbar, showSnackbar } from './snackbar.actions';
import { Action } from 'redux';
import * as Immutable from 'seamless-immutable';
import { ImmutableObject } from 'seamless-immutable';
import { isType } from 'typescript-fsa';
import { AppState } from '../reducers';

export type SnackbarTypes = 'error' | 'warning' | 'success';
interface Snackbar {
  open: boolean;
  type: SnackbarTypes;
  message: string;
}
export type SnackbarState = Snackbar & ImmutableObject<Snackbar>;

const initialState = Immutable.from<Snackbar>({
  type: 'warning',
  open: false,
  message: '',
});

export default function reduce(
  state: SnackbarState = initialState,
  action: Action
) {
  if (isType(action, showSnackbar)) {
    const {
      payload: { message, type },
    } = action;
    return state.merge({
      open: true,
      message: message,
      type: type,
    });
  }
  if (isType(action, hideSnackbar)) {
    return state.merge({
      open: false,
    });
  }
  return state;
}

export function getSnackbarState(state: AppState) {
  const { snackbar } = state;
  return snackbar;
}



// WEBPACK FOOTER //
// ./src/store/Snackbar/snackbar.reducer.ts